import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

export function formatDate(input: string | null | undefined): string {
	if (!input) return '—';
	const d = new Date(input.includes('T') ? input : input.replace(' ', 'T') + 'Z');
	if (Number.isNaN(d.getTime())) return input;
	const yyyy = d.getFullYear();
	const mm = String(d.getMonth() + 1).padStart(2, '0');
	const dd = String(d.getDate()).padStart(2, '0');
	return `${yyyy}-${mm}-${dd}`;
}

export function formatPrice(price: number | null | undefined, status: string): string {
	if (price == null) return '—';
	if (status === '出租' || status === '已租') return `¥ ${price.toLocaleString()} /月`;
	return `¥ ${price.toFixed(price % 1 === 0 ? 0 : 1)} 万`;
}
